export namespace Xnotif {
    /**
     * Notification submission endpoint
     */
    export const ENDPOINTS_SUBMIT = 'email/stock';

    /**
     * Notification submission request data
     */
    export interface IData {
        // product to notify about
        product_id: number;
        // client email
        guest_email: string;
        // newsletter sumission option
        newsletter: boolean;
        // gdpr approval
        gdpr: boolean;
    }
}
